const features = [
  {
    icon: 'ri-flashlight-line',
    title: 'Szybkie wyszukiwanie produktów',
    description: 'Znajdź setki sprawdzonych produktów w kilka sekund – bez godzin spędzonych na przeszukiwaniu chińskich platform.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Zweryfikowane linki',
    description: 'Każdy link w arkuszu został sprawdzony przez społeczność. Koniec z martwymi linkami i oszustwami.',
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Przejrzysta organizacja kategorii',
    description: 'Produkty posegregowane w 14 kategoriach – od sneakersów po elektronikę. Znajdź dokładnie to, czego szukasz.',
  },
  {
    icon: 'ri-scales-line',
    title: 'Porównanie cen i jakości',
    description: 'Porównuj ceny podobnych produktów, sprawdzaj opinie i zdjęcia QC, aby zawsze wybrać najlepszą opcję.',
  },
];

export default function WhyChooseSection() {
  return (
    <section id="why-choose" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-semibold mb-3">
            Dlaczego warto
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Dlaczego warto korzystać z Kakobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Poznaj główne zalety, które sprawiają, że tysiące użytkowników z Polski wybiera Kakobuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="group p-6 md:p-7 bg-background-50 rounded-2xl border border-background-200/70 hover:border-primary-200/60 transition-all"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all text-xl mb-4">
                <i className={feature.icon}></i>
              </span>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}